module.exports = __webpack_public_path__ + "img/img4.a41e2aa5.png";